const FILTER_FIELDS = { DATE: 'date', DEADLINE: 'deadline' } as const
const FILTER_OPERATORS = { GTE: 'gteq', LTE: 'lteq' } as const

export type FilterCondition = { field: string; operator: string; value: string }

export const buildDateConditions = (
  dateFrom?: string,
  dateTo?: string,
  deadlineFrom?: string,
  deadlineTo?: string
): FilterCondition[] => {
  const conditions: FilterCondition[] = []
  if (dateFrom)
    conditions.push({ field: FILTER_FIELDS.DATE, operator: FILTER_OPERATORS.GTE, value: dateFrom })
  if (dateTo)
    conditions.push({ field: FILTER_FIELDS.DATE, operator: FILTER_OPERATORS.LTE, value: dateTo })
  if (deadlineFrom)
    conditions.push({ field: FILTER_FIELDS.DEADLINE, operator: FILTER_OPERATORS.GTE, value: deadlineFrom })
  if (deadlineTo)
    conditions.push({ field: FILTER_FIELDS.DEADLINE, operator: FILTER_OPERATORS.LTE, value: deadlineTo })
  return conditions
}

export const buildDateFilter = (
  dateFrom?: string,
  dateTo?: string,
  deadlineFrom?: string,
  deadlineTo?: string
): string | undefined => {
  const conditions = buildDateConditions(dateFrom, dateTo, deadlineFrom, deadlineTo)
  return conditions.length > 0 ? JSON.stringify(conditions) : undefined
}
